/**
 * a direktiva forditásakor lefutó (link) függvény, ráköti az elemre a dom manipuláló kódokat
 * @author sarkiroka on 2016.07.04.
 */
import togglePasswordReadibility from './toggle-password-readibility';
export default function (scope, element, attributes) {
	var inputId = attributes.passwordView;
	$(element).mousedown(togglePasswordReadibility(inputId, true));
	$(element).mouseup(togglePasswordReadibility(inputId, false));
	$(element).mouseleave(togglePasswordReadibility(inputId, false));// erre azért van szükség, mert ha nyomott egérrel lehúzza a mutatót a szemecskéről akkor nem kapunk mouseup eseményt

	// még nincs az oldalon semmi mobilos lib ezért nativan:
	$(element)[0].addEventListener('touchstart', togglePasswordReadibility(inputId, true), false);
	$(element)[0].addEventListener('touchend', togglePasswordReadibility(inputId, false), false);
	$(element)[0].addEventListener('touchcancel', togglePasswordReadibility(inputId, false), false);
	$(element)[0].addEventListener('touchmove', togglePasswordReadibility(inputId, false), false);
};
